<template>
  <div>
    <div class="userManagement">
      <title-info>
        <li>参数设置</li>
      </title-info>
      <div class="search_input clearfix">
        <el-col :span="8">
          <span> 模块名称:&nbsp;</span>
          <el-input v-model="originData.pModuleName"></el-input>
        </el-col>
        <el-col :span="8">
          <span>参数名称:&nbsp;</span>
          <el-input v-model="originData.paramName"></el-input>
        </el-col>
        <el-col
          :span="8"
          class="clearfix"
        >
          <span>参数描述:&nbsp;</span>
          <el-input v-model="originData.remark"></el-input>
        </el-col>
      </div>
      <div
        class="search_bottom"
        style="margin-top:10px ;"
      >
        <button
          class="btn btn--search"
          @click="query()"
        >查询</button>
        <button
          class="btn btn--reset"
          @click="reset()"
        >重置</button>
      </div>
      <title-info>
        <li>查询结果列表</li>
      </title-info>
      <div class="actionButton">
        <button
          v-if="functionList.indexOf('1072')!='-1'"
          class="btn_add"
          @click="addtBtn()"
        >新增</button>
        <button
          v-if="functionList.indexOf('1073')!='-1'"
          class="btn_edit"
          @click="editBtn()"
        >修改</button>
        <button
          v-if="functionList.indexOf('1074')!='-1'"
          class="btn_del"
          @click="delBtn()"
        >删除</button>
      </div>
      <div class="param_table">
        <el-table
          :data="tableData"
          @row-click="showRow"
          tooltip-effect="dark"
        >
          <el-table-column
            label=""
            width="70"
          >
            <template slot-scope="scope">
              <el-radio
                :label="scope.row.id"
                v-model="radio"
              >&nbsp;</el-radio>
            </template>
          </el-table-column>

          <el-table-column
            label="序号"
            width="50"
          >
            <template slot-scope="scope">
              {{scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column
            prop="pModuleName"
            :show-overflow-tooltip='true'
            label="模块名称"
          >
          </el-table-column>
          <el-table-column
            prop="paramName"
            :show-overflow-tooltip='true'
            label="参数名称"
          >
          </el-table-column>
          <el-table-column
            prop="paramType"
            :show-overflow-tooltip='true'
            label="参数类型"
          >
          </el-table-column>
          <el-table-column
            prop="paramValue"
            :show-overflow-tooltip='true'
            label="参数值"
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            :show-overflow-tooltip='true'
            label="参数描述"
          >
          </el-table-column>
          <el-table-column label="最后修改时间">
            <template slot-scope="scope">
              {{scope.row.lastMod | formatTime}}
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class='pagination'>
        <span>当前共 {{sumCount}} 条信息,当前 {{currentPage}}/
          {{(Math.ceil(sumCount/pageSize)==0?1:Math.ceil(sumCount/pageSize))}}页</span>
      </div>
      <el-pagination
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next,jumper"
        :total="sumCount"
      >
      </el-pagination>
      <yh-dialog
        title="参数新增"
        :visible.sync="addDialog"
      >
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
          >
            <b class="require">* </b>模块名称：
            <el-input
              style="width: 73%"
              v-model="formData.pModuleName"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
          >
            <b class="require">* </b>参数名称：
            <el-input
              style="width: 73%"
              v-model="formData.paramName"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
            text-align="center"
          >
            <b class="require">* </b>参数类型：
            <el-input
              style="width: 73%"
              v-model="formData.paramType"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
            text-align="center"
          >&nbsp;&nbsp;
            <span class="speSpan">
              <b class="require">* </b>参数值：
            </span>
            <el-input
              type="textarea"
              style="width: 73%;margin-left:-10px"
              v-model="formData.paramValue"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
          >
            <span class="speSpan1">
              <b class="require">* </b>参数描述：
            </span>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 2}"
              placeholder="请输入内容"
              style="width: 73%"
              v-model="formData.remark"
            >
            </el-input>
          </el-col>
        </el-row>
        <div slot="footer">
          <el-button @click="addDialog = false">取 消</el-button>
          <el-button
            type="primary"
            @click="insertParamClick()"
          >确 定</el-button>
        </div>
      </yh-dialog>
      <yh-dialog
        title="参数修改"
        :visible.sync="editDialog"
      >
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
          >
            <b class="require">* </b>模块名称：
            <el-input
              style="width: 73%"
              v-model="formData.pModuleName"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
          >
            <b class="require">* </b>参数名称：
            <el-input
              style="width: 73%"
              v-model="formData.paramName"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
          >
            <b class="require">* </b>参数类型：
            <el-input
              style="width: 73%"
              v-model="formData.paramType"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
            text-align="center"
          >&nbsp;&nbsp;
            <span class="speSpan">
              <b class="require">* </b>参数值：
            </span>
            <el-input
              type="textarea"
              style="width: 73%;margin-left:-10px"
              v-model="formData.paramValue"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :span="24"
            :push="2"
          >
            <span class="speSpan1">
              <b class="require">* </b>参数描述：
            </span>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 2}"
              placeholder="请输入内容"
              style="width: 73%"
              v-model="formData.remark"
            >
            </el-input>
          </el-col>
        </el-row>
        <div slot="footer">
          <el-button
            class="btn_foot"
            @click="editDialog = false"
          >取 消</el-button>
          <el-button
            class="btn_foot_save"
            type="primary"
            @click="editRow()"
          >确 定</el-button>
        </div>
      </yh-dialog>
    </div>
  </div>
</template>
<script>
import TitleInfo from '../../../components/title.vue';
import { getFunctionList, getPagingData } from '@/mixins';

export default {
  name: 'ParamSet',
  components: {
    TitleInfo,
  },
  mixins: [getFunctionList, getPagingData],
  data() {
    return {
      // 初始数据
      originData: {
        pModuleName: '',
        paramName: '',
        remark: '',
      },
      // 查询数据
      searchParam: {
        pModuleName: '',
        paramName: '',
        remark: '',
      },
      tableData: [],
      moduleName: '',
      functionList: [],
      sumCount: 0,
      currentPage: 1,
      pageSize: 10,
      radio: '',
      formData: {
        id: '1',
        paramName: '1',
        paramValue: '1',
        paramType: '1',
        pModuleName: '1',
        remark: '1',
      },
      addDialog: false,
      editDialog: false,
      paramNameIsExistFlag: false,
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
  },
  methods: {
    // 查询按钮
    query() {
      this.searchParam = { ...this.originData };
      this.currentPage = 1;
      this.pageNo = 1;
      this.getTableData();
    },
    // 重置按钮
    reset() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
      this.radio = '';
    },
    // 获取表格数据
    getTableData() {
      this.getPagingData(this.$API.parameterQuery);
    },
    // 新增
    addtBtn() {
      this.addDialog = true;
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = '';
      });
    },
    // 新增和修改时不能为空的规则
    checkFormData() {
      const rules = [
        {
          prop: 'pModuleName',
          message: '模块名称不能为空！',
        },
        {
          prop: 'paramName',
          message: '参数名称不能为空！',
        },
        {
          prop: 'paramType',
          message: '参数类型不能为空！',
        },
        {
          prop: 'paramValue',
          message: '参数值不能为空！',
        },
        {
          prop: 'remark',
          message: '参数描述不能为空！',
        },
      ];
      return rules.every((rule) => {
        if (this.formData[rule.prop]) {
          return true;
        }
        this.$_yh_alert(rule.message);
        return false;
      });
    },
    // 新增确定
    insertParamClick() {
      this.radio = '';
      if (!this.checkFormData()) {
        return;
      }
      const params = {
        data: {
          paramName: this.formData.paramName.toString().trim(),
          paramType: this.formData.paramType.toString().trim(),
          paramValue: this.formData.paramValue.toString().trim(),
          pModuleName: this.formData.pModuleName.toString().trim(),
          remark: this.formData.remark.toString().trim(),
        },
      };
      this.$_yh_confirm('此操作将增加一条数据, 是否继续?')
        .then(() => {
          this.addParam(params);
        });
    },
    addParam(params) {
      return this.$_post(this.$API.parameterAdd, params)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.addDialog = false;
            this.$_yh_alert('新增成功！').then(() => {
              this.paramName = '';
              this.query();
            });
          } else {
            this.$_yh_alert(res.errorMsg);
          }
        });
    },
    // 选择单条数据
    showRow(row) {
      this.radio = row.id;
      this.formData = JSON.parse(JSON.stringify(row));
    },
    // 修改
    editBtn() {
      if (this.radio === '') {
        this.$_yh_alert('请选择一条记录！');
      } else {
        this.editDialog = true;
      }
    },
    // 修改确定
    editRow() {
      if (!this.checkFormData()) {
        return;
      }
      const params = {
        data: {
          id: this.formData.id,
          paramName: this.formData.paramName.toString().trim(),
          paramType: this.formData.paramType.toString().trim(),
          paramValue: this.formData.paramValue.toString().trim(),
          pModuleName: this.formData.pModuleName.toString().trim(),
          remark: this.formData.remark,
        },
      };
      this.$_yh_confirm('此操作将修改一条数据, 是否继续?')
        .then(() => {
          this.updateParam(params);
        });
    },
    updateParam(params) {
      return this.$_post(this.$API.parameterEdit, params)
        .then((res) => {
          if (res.errorCode === this.$CODE.success) {
            this.editDialog = false;
            this.$_yh_alert('修改成功!', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.paramName = '';
                this.query();
              },
            });
          } else {
            this.$_yh_alert(res.errorMsg);
          }
        });
    },
    // 删除
    delBtn() {
      if (this.radio === '') {
        this.$_yh_alert('请选择一条记录！');
      } else {
        this.$_yh_confirm('此操作将删除一条数据, 是否继续?').then(() => {
          this.deleteRow();
        });
      }
    },
    // 删除确定
    deleteRow() {
      const parames = {
        data: {
          id: this.radio,
        },
      };
      return this.$_post(this.$API.parameterDelete, parames)
        .then((res) => {
          this.$_yh_alert(res.errorMsg).then(() => {
            this.getTableData();
          });
        });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/button.scss";
.actionButton .btn_add,
.actionButton .btn_edit,
.actionButton .btn_del {
  margin: 0;
  outline: none;
  border: 0;
  color: #fff;
  font-size: 12px;
  padding: 3px 14px;
  background-color: #a2a7b3;
  height: 24px;
  border-radius: 12px;
  margin-left: 10px;
}
.btn_foot {
  padding: 10px 16px;
}
.btn_foot_save {
  padding: 10px 16px;
  background-color: #54a6de;
}
.speSpan {
  float: left;
  padding-top: 6px;
  padding-left: 14px;
}
.speSpan1 {
  float: left;
  padding-top: 6px;
  padding-left: 4px;
}
.search_input {
  width: 80%;
  height: 40%;
  margin: 0 auto;
}
.search_input .el-col {
  margin-top: 10px;
}
.actionButton {
  text-align: left;
  margin-top: 10px;
  .actionButtonRightUp {
    position: absolute;
    right: 11%;
  }
  .actionButtonRightDown {
    position: absolute;
    right: 3%;
  }
}
.el-form-item {
  height: 40px;
  width: 90%;
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 200px !important;
}
</style>
